module.exports = __webpack_public_path__ + "img/picture_kmskcspvip04@2x.e58a9bee.png";